import { ModalProps, withModalConditionalRender } from '@billy/design-system'
import { ReactElement } from 'react'

import { Account, AccountNature } from '@modules-deprecated/app/accounts/types'

import { CreateAccountFromTemplateFormContextProvider } from './contexts'
import { CreateAccountFromTemplateModalComponent } from './elements/CreateAccountFromTemplateModalComponent'

interface CreateAccountFromTemplateProps extends ModalProps {
  natures?: AccountNature[]
  onClose?: () => void
  onSave?: (account: Account) => void
}

const CreateAccountFromTemplate = ({
  natures,
  onClose,
  onSave,
  ...modalProps
}: CreateAccountFromTemplateProps): ReactElement => {
  return (
    <CreateAccountFromTemplateFormContextProvider natures={natures} onClose={onClose} onSave={onSave}>
      <CreateAccountFromTemplateModalComponent {...modalProps} />
    </CreateAccountFromTemplateFormContextProvider>
  )
}

export const CreateAccountFromTemplateModal = withModalConditionalRender(CreateAccountFromTemplate)
